import OptionHOC from '@platform/react/hoc/autocomplete/option'
import { Grid } from '@mui/material'
import { getFirstItem } from 'lib/util'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'
import Text from 'ui/Element/Text'
import Icon from 'ui/Element/Icon'
import { getSubLabel } from 'lib/util/string'

const styles = () => ({
  option: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
  icon: {
    width: '3rem',
    height: '3rem',
  },
})

/**
 * Displays the name of an organisation alongside a sub-label consisting of a concatenated string
 * of organisation type, city and number.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
const OrganisationOption = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const { option, events } = props
  const { value: { type, address = {}, number = '', name = '-' } = {} } = option || {}

  const {
    icon = 'factory',
  } = getFirstItem(events?.getOrganisationType?.(type) || [{}])

  const subLabel = getSubLabel(Text, [number, intl.address(address, { inline: true })])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.option}
    >
      <Grid
        item
        xs={'auto'}
        className={classes.icon}
      >
        <Icon
          source={icon}
          rounded={true}
          color={'text.regular'}
          background={'gray.960'}
        />
      </Grid>
      <Grid
        item
        xs={'auto'}
      >
        <Grid
          container
          height={'100%'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={name}
            variant={'14/bold'}
            color={'black.main'}
          />
          {address && number && (
            <Grid
              container
              // container
              // ms={true}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OptionHOC(OrganisationOption, styles)
